<template>
  <div class="noViewContainer">
    <el-result icon="warning" title="信息提示" subTitle="您没有权限访问该模块，若想开通此模块，请联系管理员">
     <!--  <template slot="extra">
        <el-button type="primary" size="medium">返回</el-button>
      </template> -->
    </el-result>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.noViewContainer{
  margin: 12px;
  padding: 15px 0;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  height: 95%;
}
</style>
